const sourceDataToaccount = (source, sourceId, announcementId) => {
  const email = `${source}-ad+id-${sourceId}@mellro.com`
  const password = btoa(announcementId)
  return { email, password }
}

export default sourceDataToaccount
